"use strict";
var QueueScheduler_1 = require('./QueueScheduler');
exports.queue = new QueueScheduler_1.QueueScheduler();
//# sourceMappingURL=queue.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/scheduler/queue.js
 ** module id = 460
 ** module chunks = 2
 **/